import { render, staticRenderFns } from "./merge-fields.vue?vue&type=template&id=0ab5741b&scoped=true&"
import script from "./merge-fields.vue?vue&type=script&lang=js&"
export * from "./merge-fields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab5741b",
  null
  
)

export default component.exports